import {autoinject, PLATFORM, useView} from 'aurelia-framework';
import { Router, RouterConfiguration } from 'aurelia-router';
import { IDemoRouteConfig } from 'app/demo/lib/router-types';
import { DemoContentPageBase } from 'app/demo/pages/demo-content-page-base';


@autoinject()
@useView('./demo-content-page.html')
export class DemoElementsPage extends DemoContentPageBase {

    ////****************** Fields and Properties ************************************////


    ////****************** Element References ***************************************////


    ////****************** Lifecycle events (in order of execution) *****************////
    constructor(...rest: any[]) {
        super(...rest);
        this.logger.source = this;
    }


    ////****************** Events ***************************************************////


    ////****************** Functions ************************************************////
    protected async configureRouter(config: RouterConfiguration, router: Router): Promise<void> {
        const routes: IDemoRouteConfig[] = [
            { route: '', redirect: 'ess-autocomplete' },
            {
                route: 'ess-autocomplete', name: 'demo.elements.ess-autocomplete', moduleId: PLATFORM.moduleName('app/demo/pages/elements/demo-ess-autocomplete-page'), title: 'ess-autocomplete', nav: true,
                settings: { isVisible: true, bypassAuthentication: true, helpFragment: 'gui/shared/elements/forms/ess-autocomplete.html' }
            },
            {
                route: 'ess-badge', name: 'demo.elements.ess-badge', moduleId: PLATFORM.moduleName('app/demo/pages/elements/demo-ess-badge-page'), title: 'ess-badge', nav: true,
                settings: { isVisible: true, bypassAuthentication: true, helpFragment: 'gui/shared/elements/ess-badge.html' }
            },
            {
                route: 'ess-button', name: 'demo.elements.ess-button', moduleId: PLATFORM.moduleName('app/demo/pages/elements/demo-ess-button-page'), title: 'ess-button', nav: true,
                settings: { isVisible: true, bypassAuthentication: true, helpFragment: 'gui/shared/elements/forms/ess-button.html' }
            },
            {
                route: 'ess-card', name: 'demo.elements.ess-card', moduleId: PLATFORM.moduleName('app/demo/pages/elements/demo-ess-card-page'), title: 'ess-card', nav: true,
                settings: { isVisible: true, bypassAuthentication: true, helpFragment: 'gui/shared/elements/forms/ess-card.html' }
            },
            {
                route: 'ess-checkbox', name: 'demo.elements.ess-checkbox', moduleId: PLATFORM.moduleName('app/demo/pages/elements/demo-ess-checkbox-page'), title: 'ess-checkbox', nav: true,
                settings: { isVisible: true, bypassAuthentication: true, helpFragment: 'gui/shared/elements/forms/ess-checkbox.html' }
            },
            {
                route: 'ess-checklist-element', name: 'demo.elements.ess-checklist-element', moduleId: PLATFORM.moduleName('app/demo/pages/elements/demo-ess-checklist-element-page'), title: 'ess-checklist-element', nav: true,
                settings: { isVisible: true, bypassAuthentication: true, helpFragment: 'gui/shared/elements/forms/ess-checklist-elements.html' }
            },
            {
                route: 'ess-confirm', name: 'demo.elements.ess-confirm', moduleId: PLATFORM.moduleName('app/demo/pages/elements/demo-ess-confirm-page'), title: 'ess-confirm', nav: true,
                settings: { isVisible: true, bypassAuthentication: true, helpFragment: 'gui/shared/elements/ess-confirm.html' }
            },
            {
                route: 'ess-context-menu', name: 'demo.elements.ess-context-menu', moduleId: PLATFORM.moduleName('app/demo/pages/elements/demo-ess-context-menu-page'), title: 'ess-context-menu', nav: true,
                settings: { isVisible: true, bypassAuthentication: true, helpFragment: 'gui/shared/elements/ess-context-menu.html' }
            },
            {
                route: 'ess-currency', name: 'demo.elements.ess-currency', moduleId: PLATFORM.moduleName('app/demo/pages/elements/demo-ess-currency-page'), title: 'ess-currency', nav: true,
                settings: { isVisible: true, bypassAuthentication: true, helpFragment: 'gui/shared/elements/forms/ess-currency.html' }
            },
            {
                route: 'ess-date', name: 'demo.elements.ess-date', moduleId: PLATFORM.moduleName('app/demo/pages/elements/demo-ess-date-page'), title: 'ess-date', nav: true,
                settings: { isVisible: true, bypassAuthentication: true, helpFragment: 'gui/shared/elements/forms/ess-date.html' }
            },
            {
                route: 'ess-daterange', name: 'demo.elements.ess-daterange', moduleId: PLATFORM.moduleName('app/demo/pages/elements/demo-ess-daterange-page'), title: 'ess-daterange', nav: true,
                settings: { isVisible: true, bypassAuthentication: true, helpFragment: 'gui/shared/elements/forms/ess-daterange.html' }
            },
            {
                route: 'ess-datetime', name: 'demo.elements.ess-datetime', moduleId: PLATFORM.moduleName('app/demo/pages/elements/demo-ess-datetime-page'), title: 'ess-datetime', nav: true,
                settings: { isVisible: true, bypassAuthentication: true, helpFragment: 'gui/shared/elements/forms/ess-datetime.html' }
            },
            {
                route: 'ess-dialog', name: 'demo.elements.ess-dialog', moduleId: PLATFORM.moduleName('app/demo/pages/elements/demo-ess-dialog-page'), title: 'ess-dialog', nav: true,
                settings: { isVisible: true, bypassAuthentication: true, helpFragment: 'gui/shared/elements/ess-dialog.html' }
            },
            {
                route: 'ess-dynamic-grid', name: 'demo.elements.ess-dynamic-grid', moduleId: PLATFORM.moduleName('app/demo/pages/elements/demo-ess-dynamic-grid-page'), title: 'ess-dynamic-grid', nav: true,
                settings: { isVisible: true, bypassAuthentication: true, helpFragment: 'gui/shared/elements/ess-dynamic-grid.html' }
            },
            {
                route: 'ess-dropdown', name: 'demo.elements.ess-dropdown', moduleId: PLATFORM.moduleName('app/demo/pages/elements/demo-ess-dropdown-page'), title: 'ess-dropdown', nav: true,
                settings: { isVisible: true, bypassAuthentication: true, helpFragment: 'gui/shared/elements/ess-dropdown.html' }
            },
            {
                route: 'ess-file', name: 'demo.elements.ess-file', moduleId: PLATFORM.moduleName('app/demo/pages/elements/demo-ess-file-page'), title: 'ess-file', nav: true,
                settings: { isVisible: true, bypassAuthentication: true, helpFragment: 'gui/shared/elements/forms/ess-file.html' }
            },
            {
                route: 'ess-file-progress', name: 'demo.elements.ess-file-progress', moduleId: PLATFORM.moduleName('app/demo/pages/elements/demo-ess-file-progress-page'), title: 'ess-file-progress', nav: true,
                settings: { isVisible: true, bypassAuthentication: true, helpFragment: 'gui/shared/elements/forms/ess-file-progress.html' }
            },
            {
                route: 'ess-filter', name: 'demo.elements.ess-filter', moduleId: PLATFORM.moduleName('app/demo/pages/elements/demo-ess-filter-page'), title: 'ess-filter', nav: true,
                settings: { isVisible: true, bypassAuthentication: true, helpFragment: 'gui/shared/elements/ess-filter.html' }
            },
            {
                route: 'ess-form', name: 'demo.elements.ess-form', moduleId: PLATFORM.moduleName('app/demo/pages/elements/demo-ess-form-page'), title: 'ess-form', nav: true,
                settings: { isVisible: true, bypassAuthentication: true, helpFragment: 'gui/shared/elements/forms/ess-form.html' }
            },
            {
                route: 'ess-horizontal-nav-menu', name: 'demo.elements.ess-horizontal-nav-menu', moduleId: PLATFORM.moduleName('app/demo/pages/elements/demo-ess-horizontal-nav-menu-page'), title: 'ess-horizontal-nav-menu', nav: true,
                settings: { isVisible: true, bypassAuthentication: true, helpFragment: 'gui/shared/elements/forms/ess-horizontal-nav-menu.html' }
            },
            {
                route: 'ess-info', name: 'demo.elements.ess-info', moduleId: PLATFORM.moduleName('app/demo/pages/elements/demo-ess-info-page'), title: 'ess-info', nav: true,
                settings: { isVisible: true, bypassAuthentication: true, helpFragment: 'gui/shared/elements/ess-info.html' }
            },
            {
                route: 'ess-integer', name: 'demo.elements.ess-integer', moduleId: PLATFORM.moduleName('app/demo/pages/elements/demo-ess-integer-page'), title: 'ess-integer', nav: true,
                settings: { isVisible: true, bypassAuthentication: true, helpFragment: 'gui/shared/elements/forms/ess-integer.html' }
            },
            {
                route: 'ess-logo', name: 'demo.elements.ess-logo', moduleId: PLATFORM.moduleName('app/demo/pages/elements/demo-ess-logo-page'), title: 'ess-logo', nav: true,
                settings: { isVisible: true, bypassAuthentication: true, helpFragment: 'gui/shared/elements/ess-logo.html' }
            },
            {
                route: 'ess-markdown', name: 'demo.elements.ess-markdown', moduleId: PLATFORM.moduleName('app/demo/pages/elements/demo-ess-markdown-page'), title: 'ess-markdown', nav: true,
                settings: { isVisible: true, bypassAuthentication: true, helpFragment: 'gui/shared/elements/ess-markdown.html' }
            },
            {
                route: 'ess-notifications', name: 'demo.elements.ess-notifications', moduleId: PLATFORM.moduleName('app/demo/pages/elements/demo-ess-notifications-page'), title: 'ess-notifications', nav: true,
                settings: { isVisible: true, bypassAuthentication: true, helpFragment: 'gui/shared/elements/ess-notifications.html' }
            },
            {
                route: 'ess-number', name: 'demo.elements.ess-number', moduleId: PLATFORM.moduleName('app/demo/pages/elements/demo-ess-number-page'), title: 'ess-number', nav: true,
                settings: { isVisible: true, bypassAuthentication: true, helpFragment: 'gui/shared/elements/forms/ess-number.html' }
            },
            {
                route: 'ess-pager', name: 'demo.elements.ess-pager', moduleId: PLATFORM.moduleName('app/demo/pages/elements/demo-ess-pager-page'), title: 'ess-pager', nav: true,
                settings: { isVisible: true, bypassAuthentication: true, helpFragment: 'gui/shared/elements/ess-pager.html' }
            },
            {
                route: 'ess-radio', name: 'demo.elements.ess-radio', moduleId: PLATFORM.moduleName('app/demo/pages/elements/demo-ess-radio-page'), title: 'ess-radio', nav: true,
                settings: { isVisible: true, bypassAuthentication: true, helpFragment: 'gui/shared/elements/forms/ess-radio.html' }
            },
            {
                route: 'ess-ribbon-link', name: 'demo.elements.ess-ribbon-link', moduleId: PLATFORM.moduleName('app/demo/pages/elements/demo-ess-ribbon-link-page'), title: 'ess-ribbon-link', nav: true,
                settings: { isVisible: true, bypassAuthentication: true, helpFragment: 'gui/shared/elements/display/ess-ribbon-link.html' }
            },
            {
                route: 'ess-rule', name: 'demo.elements.ess-rule', moduleId: PLATFORM.moduleName('app/demo/pages/elements/demo-ess-rule-page'), title: 'ess-rule', nav: true,
                settings: { isVisible: true, bypassAuthentication: true, helpFragment: 'gui/shared/elements/ess-rule.html' }
            },
            {
                route: 'ess-select', name: 'demo.elements.ess-select', moduleId: PLATFORM.moduleName('app/demo/pages/elements/demo-ess-select-page'), title: 'ess-select', nav: true,
                settings: { isVisible: true, bypassAuthentication: true, helpFragment: 'gui/shared/elements/forms/ess-select.html' }
            },
            {
                route: 'ess-sortable-list', name: 'demo.elements.ess-sortable-list', moduleId: PLATFORM.moduleName('app/demo/pages/elements/demo-ess-sortable-list-page'), title: 'ess-sortable-list', nav: true,
                settings: { isVisible: true, bypassAuthentication: true, helpFragment: 'gui/shared/elements/ess-sortable-list.html' }
            },
            {
                route: 'ess-switch', name: 'demo.elements.ess-switch', moduleId: PLATFORM.moduleName('app/demo/pages/elements/demo-ess-switch-page'), title: 'ess-switch', nav: true,
                settings: { isVisible: true, bypassAuthentication: true, helpFragment: 'gui/shared/elements/forms/ess-switch.html' }
            },
            {
                route: 'ess-table', name: 'demo.elements.ess-table', moduleId: PLATFORM.moduleName('app/demo/pages/elements/demo-ess-table-page'), title: 'ess-table', nav: true,
                settings: { isVisible: true, bypassAuthentication: true, helpFragment: 'gui/shared/elements/ess-table.html' }
            },
            {
                route: 'ess-tabs-horizontal', name: 'demo.components.ess-tabs-horizontal', moduleId: PLATFORM.moduleName('app/demo/pages/elements/demo-ess-tabs-horizontal-page'), title: 'ess-tabs-horizontal', nav: true,
                settings: { isVisible: true, bypassAuthentication: true, helpFragment: 'gui/shared/elements/ess-tabs-horizontal.html' }
            },
            {
                route: 'ess-tabs-vertical', name: 'demo.components.ess-tabs-vertical', moduleId: PLATFORM.moduleName('app/demo/pages/elements/demo-ess-tabs-vertical-page'), title: 'ess-tabs-vertical', nav: true,
                settings: { isVisible: true, bypassAuthentication: true, helpFragment: 'gui/shared/elements/ess-tabs-vertical.html' }
            },
            {
                route: 'ess-text', name: 'demo.elements.ess-text', moduleId: PLATFORM.moduleName('app/demo/pages/elements/demo-ess-text-page'), title: 'ess-text', nav: true,
                settings: { isVisible: true, bypassAuthentication: true, helpFragment: 'gui/shared/elements/forms/ess-text.html' }
            },
            {
                route: 'ess-textarea', name: 'demo.elements.ess-textarea', moduleId: PLATFORM.moduleName('app/demo/pages/elements/demo-ess-textarea-page'), title: 'ess-textarea', nav: true,
                settings: { isVisible: true, bypassAuthentication: true, helpFragment: 'gui/shared/elements/forms/ess-textarea.html' }
            },
            {
                route: 'ess-time', name: 'demo.elements.ess-time', moduleId: PLATFORM.moduleName('app/demo/pages/elements/demo-ess-time-page'), title: 'ess-time', nav: true,
                settings: { isVisible: true, bypassAuthentication: true, helpFragment: 'gui/shared/elements/forms/ess-time.html' }
            },
            {
                route: 'ess-tooltip', name: 'demo.elements.ess-tooltip', moduleId: PLATFORM.moduleName('app/demo/pages/elements/demo-ess-tooltip-page'), title: 'ess-tooltip', nav: true,
                settings: { isVisible: true, bypassAuthentication: true, helpFragment: 'gui/shared/elements/ess-tooltip.html' }
            }
        ];
        config.map(routes);

        config.mapUnknownRoutes('app/shared/components/not-found');

        this.router = router;
    }

    ////****************** Service Calls ********************************************////

}
